// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseCross_closeButton__jvDPU"};